// src/components/CriticalPathHorizontal/CpEntityChat.js
import EntityChat from "../Chat/EntityChat";
import EntityChatNotasPanel from "../Chat/EntityChatNotasPanel";

/** Resolve chat entity from CP note keys (pedido > producto). */
export function resolveCpChatEntity({
  productId = null,
  idPresupuestoA3Pedido = null,
} = {}) {
  const pedidoId =
    idPresupuestoA3Pedido != null &&
    Number.isFinite(Number(idPresupuestoA3Pedido))
      ? Number(idPresupuestoA3Pedido)
      : null;
  if (pedidoId) {
    return { entityType: "PedidoA3", entityId: pedidoId };
  }
  const prodId =
    productId != null && Number.isFinite(Number(productId))
      ? Number(productId)
      : null;
  if (prodId) {
    return { entityType: "Producto", entityId: prodId };
  }
  return { entityType: null, entityId: null };
}

export function getCpChatMetaKey({
  productId = null,
  idPresupuestoA3Pedido = null,
  entityType = null,
  entityId = null,
} = {}) {
  if (entityType && entityId != null && Number.isFinite(Number(entityId))) {
    return `${entityType}:${Number(entityId)}`;
  }
  const resolved = resolveCpChatEntity({ productId, idPresupuestoA3Pedido });
  if (!resolved.entityType || resolved.entityId == null) return null;
  return `${resolved.entityType}:${resolved.entityId}`;
}

export function getCpChatMetaKeyFromRow(row) {
  if (!row) return null;
  return getCpChatMetaKey({
    productId: row.productId ?? row.ProductId ?? null,
    idPresupuestoA3Pedido: row.IdPresupuestoA3Pedido ?? null,
  });
}

export default function CpEntityChat({
  open,
  onClose,
  productId = null,
  idPresupuestoA3Pedido = null,
  title = "",
  subtitle = "",
  initialTab = "notas",
  onNotasChanged,
}) {
  const { entityType, entityId } = resolveCpChatEntity({
    productId,
    idPresupuestoA3Pedido,
  });

  if (!entityType || !entityId) return null;

  const notaProductId = entityType === "Producto" ? entityId : null;
  const notaPedidoId = entityType === "PedidoA3" ? entityId : null;

  return (
    <EntityChat
      open={open}
      onClose={onClose}
      entityType={entityType}
      entityId={entityId}
      title={title || String(entityId)}
      subtitle={subtitle}
      initialTab={initialTab}
      secondaryTab={{
        label: "Notas",
        content: (
          <EntityChatNotasPanel
            active={open}
            productId={notaProductId}
            idPresupuestoA3Pedido={notaPedidoId}
            onChanged={onNotasChanged}
          />
        ),
      }}
    />
  );
}
